import Vue from 'vue';
import axios from 'axios';
import configRepository from '../repositories/ConfigRepository';

var translationService = function () {

    var vm = new Vue({
        data: {
            TranslationsDictionary: {}
        }
    })

    var _config = configRepository.getConfig();

    var _init = () => {
        var headers = {};
        headers.PwaEnableCache = 1;

        var data = {
            culture: _config.selectedCulture
        }

        var url = _config.endPointUrl + "api/Translate/GetDictionary";

        axios({
            method: 'GET',
            url: url,
            params: data,
            withCredentials: false
        }).then(function (response) {
            success(response)
        }).catch(function (err) {
            error(err);
        });

        function success(data) {
            data.data.forEach(e => Vue.set(vm.TranslationsDictionary, e.key, e.value));
        }

        function error() { }
    };

    _init();

    var _GetTranslation = (translation) => {
        return vm.TranslationsDictionary[translation] || '[' + translation + ']';
    }

    var _ReloadTranslations = () => {
        _config = configRepository.getConfig();

        _init();
    };

    return {
        TranslationsDictionary: vm.TranslationsDictionary,
        GetTranslation: _GetTranslation,
        ReloadDictionary: _ReloadTranslations
    }
}();

export default translationService;
